import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

import { Section, Card, Text, Title, ImageContainer, Container } from './styles'

import { Heading } from '../HomepageProducts/styles'

const TrustedBy = () => {
  const { returns, support, secure, usaBased } = useStaticQuery(graphql`
    query TrustedByQuery {
      returns: file(relativePath: { eq: "homepage/returns.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      support: file(relativePath: { eq: "homepage/support.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      secure: file(relativePath: { eq: "homepage/secure.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      usaBased: file(relativePath: { eq: "homepage/usaBased.webp" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)

  const features = [
    {
      id: 'returns',
      image: returns,
      title: '4-Month Free Returns',
      description: 'Send it back, no questions asked.',
    },
    {
      id: 'support',
      image: support,
      title: 'Real 1:1 Support',
      description: 'Get help from a real person.',
    },
    {
      id: 'secure',
      image: secure,
      title: 'Secure & Private',
      description: `Your family's data stays safe.`,
    },
    {
      id: 'usaBased',
      image: usaBased,
      title: 'US-Based Company',
      description: 'Operated right here in the States.',
    },
  ]
  return (
    <Section>
      <Heading padding>Trusted by Over 1 Million Families</Heading>
      <Container>
        {features.map(({ id, title, image, description }) => (
          <Card key={id}>
            <ImageContainer key={id} id={id}>
              <GatsbyImage image={image.childImageSharp.gatsbyImageData} alt={title} />
            </ImageContainer>
            <Title>{title}</Title>
            <Text>{description}</Text>
          </Card>
        ))}
      </Container>
    </Section>
  )
}

export default TrustedBy
